module.exports = __webpack_public_path__ + "img/guetesiegelverband.a8f83e4a.svg";